<template>
  <div class="object-agency-logo mt-3 mb-2">
    <div class="small text-muted">
      {{ $t('agency:logoObjectHeadline') }}
    </div>
    <template v-if="agencyLinkIntern != ''">
      <a
        :href="agencyLinkIntern"
        :title="agencyName"
      >
        <img
          :src="agencyLogoLink"
          :alt="agencyName"
        >
      </a>
    </template>
    <template v-else>
      <img
        :src="agencyLogoLink"
        :alt="agencyName"
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    agencyName: {
      type: String,
      required: true,
    },
    agencyLinkIntern: {
      type: String,
      required: true,
    },
    agencyLogoLink: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
  .object-agency-logo {
    a {
      display: inline-block;
    }

    img {
      display: block;
      margin: 0 0 1em 0;
    }
  }
</style>
